import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'

console.log('🚀 main.jsx: Iniciando aplicação...');

try {
  const rootElement = document.getElementById('root');
  console.log('🚀 main.jsx: Elemento root encontrado:', !!rootElement);

  if (!rootElement) {
    console.error('🚀 main.jsx: Elemento root não encontrado!');
    throw new Error('Elemento root não encontrado');
  }

  // Loading inicial já está oculto por padrão no HTML

  const root = ReactDOM.createRoot(document.getElementById('root'));
  console.log('🚀 main.jsx: React root criado');

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  console.log('🚀 main.jsx: App renderizada');

} catch (error) {
  console.error('🚀 main.jsx: Erro ao inicializar:', error);

  // Ocultar loading em caso de erro também
  const loadingContainer = document.querySelector('.loading-container');
  if (loadingContainer) {
    loadingContainer.classList.add('hidden');
  }

  // Fallback: mostrar erro na página
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="padding: 20px; color: red; background: white; border: 2px solid red; margin: 20px; border-radius: 8px;">
        <h2>❌ Erro no Sistema de Inventário</h2>
        <p><strong>Erro:</strong> ${error.message}</p>
        <p>Verifique o console do navegador (F12) para mais detalhes.</p>
        <hr>
        <p><strong>Solução:</strong></p>
        <ol>
          <li>Abra o console do navegador (F12)</li>
          <li>Verifique os erros em vermelho</li>
          <li>Recarregue a página (Ctrl+F5)</li>
        </ol>
      </div>
    `;
  }
}
